var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.295282 1.72672C-0.0984268 1.33171 -0.0984275 0.691269 0.295281 0.296258C0.68899 -0.0987527 1.32732 -0.0987526 1.72103 0.296258L9.59022 8.19147C9.98393 8.58648 9.98393 9.22692 9.59022 9.62193C9.19651 10.0169 8.55818 10.0169 8.16447 9.62193L0.295282 1.72672Z","fill":"#A5A9AF","key":0}),React.createElement("path",{"d":"M8.27897 0.378068C8.67268 -0.0169426 9.31101 -0.0169432 9.70472 0.378067C10.0984 0.773078 10.0984 1.41352 9.70472 1.80853L1.83553 9.70374C1.44182 10.0988 0.80349 10.0988 0.409781 9.70374C0.0160725 9.30873 0.0160725 8.66829 0.409781 8.27328L8.27897 0.378068Z","fill":"#A5A9AF","key":1})]);
}

CloseIconInline.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
